export function initialize(appId: string, onLoad: () => void, onError?: (error: Error) => void) {
  if (!!appId && typeof window !== 'undefined' && typeof (window as any).Pylon === 'undefined') {
    const appendScript = function () {
      setTimeout(function () {
        const s = document.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.onload = () => {
          onLoad()
        }
        s.onerror = (event) => {
          const error = new Error('Failed to load Pylon widget script')
          console.warn('Failed to load Pylon widget:', event)
          onError?.(error)
        }

        // Add timeout handling
        const timeoutId = setTimeout(() => {
          const error = new Error('Pylon widget loading timed out')
          console.warn('Pylon widget loading timed out')
          onError?.(error)
        }, 10000) // 10 second timeout

        s.onload = () => {
          clearTimeout(timeoutId)
          onLoad()
        }

        s.src = `https://widget.usepylon.com/widget/${appId}`
        const x = document.getElementsByTagName('script')[0]
        x?.parentNode?.insertBefore(s, x)
      }, 0)
    }

    if (document.readyState === 'complete') {
      appendScript()
    } else {
      window.addEventListener('load', appendScript, false)
    }
  }
}
